import CashbacksTable from './CashbacksTable';

export default CashbacksTable;
